import React from 'react';
import LazyImage from '../lazy-image';
import { getFluidGatsbyImage } from '../../utils/gatsby-storyblok-image-fixed';
import RichtextParser from '../../utils/richtext-parser';
import parseStoryblokLink from '../../utils/parseStoryblokLink';
import styled, { css } from 'styled-components';
import { Link } from 'gatsby';
import mq from '../../utils/mq';

const SolutionItemContainer = styled.div`
  width: 100%;
  display: flex;
  gap: 64px;
  justify-content: space-between;
  &.right-align {
    flex-direction: row-reverse;
  }
  ${mq.mobile(css`
    flex-direction: column;
    gap: 32px;
    &.right-align {
      flex-direction: column;
    }
  `)};
`;

const ImageContainer = styled.div`
  background: #f8f8f8;
  height: 295px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 30px;
  box-sizing: content-box;
  border-radius: var(--Radius-Radius-3, 16px);
  overflow: hidden;
  ${mq.mobile(css`
    height: unset;
    box-sizing: border-box;
  `)};
`;

const Image = styled.div`
  width: 100%;
  height: 100%;
`;

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  width: 100%;
`;

const Title = styled.h3`
  color: #161616;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 125%;
  letter-spacing: -0.48px;
`;

const DescriptionContent = styled.div`
  color: #666;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 160%;
  letter-spacing: -0.36px;
  padding-top: 16px;
  padding-bottom: 20px;
`;

const CtaLabel = styled(Link)`
  color: #813dff;
  text-decoration: none;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 140%;
`;

export default function SolutionItem({
  title,
  description,
  ctaText,
  ctaLink,
  image,
  leftAligned
}: {
  title: string;
  description: any;
  ctaText: string;
  ctaLink: any;
  image: any;
  leftAligned?: boolean;
}) {
  return (
    <SolutionItemContainer
      className={leftAligned ? 'left-align' : 'right-align'}
    >
      <ImageContainer>
        <Image>
          <LazyImage
            fluid={getFluidGatsbyImage(image)}
            width={'100%'}
            height={'100%'}
            style={{ objectFit: 'scale-down' }}
          />
        </Image>
      </ImageContainer>
      <ContentContainer>
        <Title>{title}</Title>
        <DescriptionContent
          dangerouslySetInnerHTML={{ __html: RichtextParser(description) }}
        />
        <CtaLabel to={`/${parseStoryblokLink(ctaLink)}`}>{ctaText}</CtaLabel>
      </ContentContainer>
    </SolutionItemContainer>
  );
}
